import React, { ReactElement } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import Loader from './Loader';
import { convertToTitleCase } from './Util';

interface ComponentProps {
    size: string;
    cancelText?: string;
    loading?: boolean;
    saveText?: string;
    isHeader: boolean;
    disabled?: boolean;
    show: boolean;
    handleModalBody: () => ReactElement;
    handleClick?: () => void;
    onCloseClick: React.MouseEventHandler<any>;
    headerClass: string;
    modalheader: string;
    hideSaveButton?: boolean;
    hideCancelButton?: boolean;
    bodyClass?: string;
    footerClass?: string;
    hideFooterButtons?: boolean;
    hideCaseButton?: boolean;
    naviagteToCase?: any;
    isStaticBackdrop?: any;
    isHideToogleClose?: boolean;
    topModal?: any;
    disabledKeywordsActions?: any;
    validation?: any;
    backgroundColor?: any;
    headerColor?: any;
    hideRejectButton?: boolean;
    handleReject?: () => void;
    handleProfileEdit?: () => void;
    isReject?: boolean;
    profileButtons?: any;
    profileEditButton?: any;
    profileUpdateButton?: any;
}

const CommonModal: React.FC<ComponentProps> = ({
    show,
    size,
    isHeader,
    handleClick,
    onCloseClick,
    cancelText,
    saveText,
    modalheader,
    handleModalBody,
    disabled,
    hideSaveButton,
    hideCancelButton,
    headerClass,
    bodyClass,
    footerClass,
    hideFooterButtons,
    hideCaseButton,
    naviagteToCase,
    isStaticBackdrop,
    loading,
    topModal,
    disabledKeywordsActions,
    validation,
    isHideToogleClose,
    backgroundColor,
    headerColor,
    isReject,
    handleReject,
    handleProfileEdit,
    profileButtons,
    profileEditButton,
    profileUpdateButton
}) => {
    return (
        <Modal
            isOpen={show}
            toggle={onCloseClick}
            centered={topModal ? false : true}
            id={isStaticBackdrop ? 'topmodal' : undefined}
            size={size}
            className="bg-custom-white border border-0"
            //  className={`bg-custom-white ${backgroundColor ? 'border-0' : ''}`}
            backdrop={loading ? 'static' : isStaticBackdrop ? 'static' : true} // ⬅️ disables backdrop close
            keyboard={loading ? false : disabledKeywordsActions ? false : true} // ⬅️ disables ESC key
        >
            {isHeader && (
                <ModalHeader

                    className={`p-3  border-bottom ${headerClass} ${headerColor ? headerColor : ''} bg-custom-white ${backgroundColor ? 'primary-bgcolor' : ''
                        }`}
                    toggle={loading ? undefined : isHideToogleClose ? undefined : onCloseClick} // ✅ disable X when loading

                >
                    {convertToTitleCase(modalheader)}
                </ModalHeader>
            )}
            <ModalBody
                className={`${bodyClass} position-relative`}
                style={{
                    maxHeight: profileButtons ? 'calc(100vh - 250px)' : 'calc(100vh - 150px)',
                    overflowY: 'auto'
                }}
            >
                {handleModalBody()}
                {/* Disable body interactions when loading */}
                {loading && (
                    <div
                        className="modal-body-overlay"
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            background: 'rgba(255,255,255,0.6)',
                            backdropFilter: 'blur(2px)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 10,
                            pointerEvents: 'all',
                            cursor: 'not-allowed'
                        }}
                    >
                        <Loader />
                    </div>
                )}
                {hideCaseButton && (
                    <div className="d-flex justify-content-center">
                        <Button outline className="w-sm" color="radiogramPrimary" data-bs-dismiss="modal" onClick={naviagteToCase}>
                            {cancelText ? cancelText : 'Close'}
                        </Button>
                    </div>
                )}
            </ModalBody>
            {!hideFooterButtons && (
                <ModalFooter className={` ${footerClass}`}>
                    <div className="d-flex gap-2 justify-content-end mt-3 mb-2">
                        {!hideCancelButton && (
                            <Button
                                outline
                                className="w-sm btn-outline-success border-2 br-6 font-weight-600 font-size-14"
                                color="radiogramPrimary"
                                data-bs-dismiss="modal"
                                onClick={isReject ? handleReject : onCloseClick}
                                disabled={loading}
                            >
                                {cancelText ? cancelText : 'Close'}
                            </Button>
                        )}
                        {!hideSaveButton && (
                            <button
                                type="submit"
                                className="btn w-sm btn-primary br-6 text-secondary font-weight-600 font-size-14"
                                disabled={disabled}
                                onClick={() => {
                                    validation && validation.submitForm();
                                    handleClick && handleClick();
                                }}
                            >
                                {saveText ? saveText : 'OK'}
                            </button>
                        )}
                    </div>
                </ModalFooter>
            )}
            {profileButtons && (
                <ModalFooter className="d-flex gap-2 justify-content-center mt-3 mb-2">
                    <div>
                        {!profileEditButton && (
                            <Button
                                outline
                                className="w-sm btn-outline-success border-2 br-6 font-weight-600 font-size-14"
                                color="radiogramPrimary"
                                data-bs-dismiss="modal"
                                onClick={handleProfileEdit}
                            >
                                {'Edit'}
                            </Button>
                        )}
                        {profileEditButton && (
                            <button
                                type="submit"
                                className="btn w-sm btn-primary br-6 text-secondary font-weight-600 font-size-14"
                                disabled={!validation.dirty || !validation.isValid}
                                onClick={() => {
                                    // validation && validation.submitForm();
                                    handleClick && handleClick();
                                }}
                            >
                                {'Update'}
                            </button>
                        )}
                    </div>
                </ModalFooter>
            )}
        </Modal>
    );
};

export default CommonModal;
